import {useState} from 'react';

import {
    Button,
    Indicator,
} from '@mantine/core';
import {AiOutlineFilter} from 'react-icons/ai';
import {I18n} from '@aws-amplify/core';

import {FilterDrawer} from '../drawers/FilterDrawer';
import {useInvoicesFilter} from '../hooks/useInvoicesFilter';

/**
 * FNP-918: opens the FilterDrawer, with an ACTIVE-FILTER-COUNT BADGE (§7).
 *
 * The badge is the point: a filter you cannot see is a filter you forget is on,
 * and an operator then reads a narrowed list as the whole dataset. Drawer state
 * is local to this button, not global (§7).
 */
export const FilterRecordsButton = () => {
    const [drawerOpened, setDrawerOpened] = useState(false);
    const {activeFilterCount} = useInvoicesFilter();

    return (
        <>
            <Indicator
                label={activeFilterCount}
                size={16}
                disabled={activeFilterCount === 0}
                aria-label={I18n.get('Active filters')}
            >
                <Button
                    variant='default'
                    leftSection={<AiOutlineFilter/>}
                    onClick={() => setDrawerOpened(true)}
                >
                    {I18n.get('Filter')}
                </Button>
            </Indicator>

            <FilterDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </>
    );
};
